import { render, staticRenderFns } from "./resource-settings.vue?vue&type=template&id=27a1ea80&"
import script from "./resource-settings.vue?vue&type=script&lang=js&"
export * from "./resource-settings.vue?vue&type=script&lang=js&"
import style0 from "./resource-settings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27a1ea80')) {
      api.createRecord('27a1ea80', component.options)
    } else {
      api.reload('27a1ea80', component.options)
    }
    module.hot.accept("./resource-settings.vue?vue&type=template&id=27a1ea80&", function () {
      api.rerender('27a1ea80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/resource-settings.vue"
export default component.exports